import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useAuth } from '../../../../hooks/useAuth';
import { getSellMaterialList } from '../../../../services/material-services';
import { Button, Fab, IconButton, Typography } from '@mui/material';
import moment from "moment-jalaali";
import PropTypes from 'prop-types';
import {NotificationManager} from 'react-notifications';
import { sellMatWorkInsert } from '../../../../services/material-services';
import { blue } from '@mui/material/colors';
import DialogDetailEdit from './dialog-detail-edit';
import AddIcon from '@mui/icons-material/Add';


function Row(props) {
    const { authData } = useAuth()
    const { row, onClose, dataUserReq, ReqUser, isAdmin } = props
    const [open, setOpen] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [rowSelect, setRowSelect] = useState(false)

    const handleClose = value => {
        if(isAdmin){
            setOpenDialog(true)
            setRowSelect(value)
        }
    }
    
    const handleDialogClose = value => {
        // console.log(value)
        onClose(value)
        setOpenDialog(false)
        // setSelectedValue(value)
    }

    const handlerStartProject = async value => {
        // e.target.value
        const workAdd = {sell_mat:ReqUser?.sell_req_buys.id , sell_mat_detail: value?.id, 
            user: authData.user?.id, project_status: [2]}
        // console.log(workAdd)
        setLoading(true)
        let addNewBuyMaterial = await sellMatWorkInsert(authData.token, workAdd)

        onClose(workAdd)
        // console.log("addNewBuyMaterial", addNewBuyMaterial)
        if (addNewBuyMaterial){
            NotificationManager.success('کار جدید به برنامه اضافه شد')
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان ثبت کار وجود دارد')
        }
        setLoading(false)
    }

    return (
        <React.Fragment>
            {isAdmin &&
                <DialogDetailEdit row={rowSelect} dataUserReq={dataUserReq} open={openDialog} onClose={handleDialogClose}/>
            }
            <TableRow sx={{ '& > *': { borderBottom: 'unset', backgroundColor:'pink.text' } }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                        >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell 
                    component="th" 
                    scope="row" 
                    sx={{textAlign: 'center'}}
                    >
                    <Button onClick={() => handleClose(row)}>
                        <Typography 
                            fontFamily='b_mitra' 
                            component="b"
                            variant="h6"
                            color='secondary'
                            noWrap
                            >
                            {row.bio_step}
                        </Typography>
                    </Button>
                </TableCell>
                <TableCell align="right" sx={{textAlign: 'center'}}>
                    <Typography 
                        fontFamily='b_mitra' 
                        component="b"
                        variant="b"
                        color={blue[900]}
                        >
                            {moment(row?.time, 'YYYY-M-D').format('jYYYY/jM/jD')}
                        
                    </Typography>
                </TableCell>
                <TableCell align="right" sx={{textAlign: 'center'}}>
                    <Typography 
                        fontFamily='b_mitra' 
                        component="b"
                        variant="b"
                        color={blue[900]}
                        >
                            {moment(row?.start_time, 'YYYY-M-D').format('jYYYY/jM/jD')}
                            {/* {shamsi.gregorianToJalali(row?.start_time).join('/')} */}
                    </Typography>
                </TableCell>
                <TableCell align="right" sx={{textAlign: 'center'}}>
                    <Typography 
                        fontFamily='b_mitra' 
                        component="b"
                        variant="b"
                        color={blue[900]}
                        >
                            {moment(row?.expire_time, 'YYYY-M-D').format('jYYYY/jM/jD')}
                            {/* {shamsi.gregorianToJalali(row?.expire_time).join('/')} */}
                    </Typography>
                </TableCell>
                <TableCell align="right" sx={{textAlign: 'center'}}>
                    <Typography 
                        fontFamily='b_mitra' 
                        component="b"
                        variant="b"
                        noWrap
                        color={blue[900]}
                        >
                        {row.remarks}
                    </Typography>
                </TableCell>
                <TableCell align="right" sx={{textAlign: 'center'}}>
                    <Button 
                        variant="contained" color="primary"
                        size="large" 
                        sx={{
                            textAlign: 'right',
                            margin: 1,
                        }}
                        onClick={() => handlerStartProject(row)}
                        >
                        <Typography
                            fontFamily='b_mitra' 
                            component="b"
                            variant="b"
                            color={'pink.text'}
                            >
                            درخواست پروژه
                        </Typography>
                    </Button>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1, backgroundColor: blue[600], width: '100%' }} >
                            <Typography 
                                fontFamily='b_mitra' 
                                gutterBottom 
                                component="b"
                                variant="h6"
                                color={'pink.text'}
                                >
                                شروع به کار
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{textAlign: 'center'}}>
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="b"
                                                variant="b"
                                                color={'pink.text'}
                                                >
                                                تاریخ ثبت
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{textAlign: 'center'}}>
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="b"
                                                variant="b"
                                                color={'pink.text'}
                                                >
                                                درصد پیشرفت
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right" sx={{textAlign: 'center'}}>
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="b"
                                                variant="h7"
                                                color={'pink.text'}
                                                >
                                                وضعیت
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right" sx={{textAlign: 'center'}}>
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="b"
                                                variant="b"
                                                color={'pink.text'}
                                                >
                                                توضیحات
                                        </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{backgroundColor: 'white'}}>
                                    {row?.sell_detail_works && row?.sell_detail_works?.map((historyRow) => (
                                    <TableRow key={historyRow?.id}>
                                        <TableCell 
                                            component="div" 
                                            scope="row"
                                            sx={{textAlign: 'center'}}
                                            >
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="b"
                                                color="black"
                                                >
                                                {moment(historyRow?.time, 'YYYY-M-D HH:mm').format('jYYYY/jM/jD HH:mm')}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{textAlign: 'center'}}>
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="b"
                                                color="black"
                                                >
                                                {historyRow?.project_progress}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right" sx={{textAlign: 'center'}}>
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="b"
                                                color="black"
                                                >
                                                {historyRow?.projectstatus}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right" sx={{textAlign: 'center'}}>
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="b"
                                                color="black"
                                                >
                                                {historyRow?.remarks}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

Row.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  // selectedValue: PropTypes.string.isRequired,
}

export default function DialogSellDetail({userClient, ReqUser}) {
    const { authData } = useAuth()
    const [isAdmin, setIsAdmin] = useState(false)
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [dataUserReq, setDataUserReq] = useState()
    const [openDialog, setOpenDialog] = useState(false)

    const handleDialogShow = value => {
        setOpenDialog(true)
    }
    
    const handleDialogClose = value => {
        // console.log(value)
        setOpenDialog(false)
        getData()
        // setSelectedValue(value)
    }

    const getData = async() =>{
        await getSellMaterialList(authData?.token, userClient?.id)
        .then(data => {
            
            // console.log("Dialog_Answer3", data)
            setDataUserReq(data?.results[0])
            
            // setUserClient(data?.results)

            setLoading(false)
        }).catch( e => {
            // setError(true)
            setLoading(false)
        })
    }
    useEffect(()=>{
        // console.log(selectedValue)
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        
        setLoading(true)
        // console.log("Dialog_Answer2", userClient)
        if(userClient?.id){
            getData()
        }
            
    }, [authData, userClient])

    const handleClose =  value => {
        if(userClient?.id){
            getData()
        }
    }

  return (
    <React.Fragment>
        <div >
            {isAdmin &&
                <Fab 
                    size="medium" color="secondary"
                    role="presentation"
                    onClick={handleDialogShow}
                    >
                    <AddIcon />
                </Fab>
            }
            <TableContainer component={Paper} sx={{backgroundColor: blue[900]}}>
                <Table aria-label="collapsible table">
                    <TableHead>
                    <TableRow >
                        <TableCell />
                        <TableCell sx={{textAlign: 'center'}}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={'pink.text'}
                                >
                                مراحل
                            </Typography>
                        </TableCell>
                        <TableCell align="right" sx={{textAlign: 'center'}}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={'pink.text'}
                                >
                                تاریخ ثبت
                            </Typography>
                        </TableCell>
                        <TableCell align="right" sx={{textAlign: 'center'}}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={'pink.text'}
                                >
                                تاریخ شروع
                            </Typography>
                        </TableCell>
                        <TableCell align="right" sx={{textAlign: 'center'}}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={'pink.text'}
                                >
                                تاریخ اتمام
                            </Typography>
                        </TableCell>
                        <TableCell align="right" sx={{textAlign: 'center'}}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={'pink.text'}
                                >
                                توضیحات
                            </Typography>
                        </TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {dataUserReq && dataUserReq.sell_mats.map((row) => (
                        <Row 
                            key={row.id} 
                            row={row} 
                            onClose={handleClose} 
                            dataUserReq={dataUserReq} 
                            ReqUser={ReqUser}
                            isAdmin={isAdmin}
                            />
                    ))}
                    </TableBody>
                </Table>

            </TableContainer>
            
            <DialogDetailEdit dataUserReq={dataUserReq} open={openDialog} onClose={handleDialogClose}/>
        </div>
      </React.Fragment>
    )
}